import React, {useState, useEffect}     from 'react'


import {TwoTimeEdit}                    from '../../lib/iprs-react-library/src/index.js';
import {OKCancel}                       from '../../lib/iprs-react-library/src/index.js';
import {getTimeStr}                     from '../../lib/iprs-react-library/src/index.js';
import AppTypeSelector                  from '../AppointmentType/AppTypeSelect';
import {ROTA_TYPE_AVAIABLE}             from '../../lib/iprs-react-library/src/index.js';
import {isRotaTypeHidden}               from '../../hiddenRotaTypes';


/* 
 * REACTJs component to display an overlay over the diary for editing 
 * availablility
 */
const TemplateCalendarOverlay = ({api, selectInfo, done, appointmentTypes}) => {    

    // bit ugly
    const {event: {start, end, extendedProps: 
        { apiEvent = {} } = {} }, templateID }          = selectInfo;
    const {
        fkRotaTypeID = 0,
        preSelectedAppTypes = [],
        pkRotaWeekTemplateEntryID: rotaWeekTemplateEntryID,
        RowVersion: rowVersion
    }                                       = apiEvent
    
    const dayOfWeek                         = start.getDay()

    const [rTypeList, setRTypeList]         = useState([])
    
    /* If this is a new entry then use ROTA_TYPE_AVAIABLE which markes availablity
     * otherwise use what's set on the existing object. In other words default to 
     * availablilty rather than task type. */
    const [rotaTypeID,      setRotaTypeID]  = useState(rotaWeekTemplateEntryID? fkRotaTypeID: ROTA_TYPE_AVAIABLE);

    const [selectedAppTypes, setSelectedAppTypes]   = useState(preSelectedAppTypes.map( t => t.pkAppointmentTypeID ));
    const [startTime, setStartTime]         = useState(start)
    const [endTime,   setEndTime]           = useState(end)

    /* only ok if you've selected at least on app type 
     * Use True all the time now as people use availablilty for nothing, to mark
     * working hours */
    const okEnabled = true; //ROTA_TYPE_AVAIABLE !== rotaTypeID || 0 !== selectedAppTypes.length;

    const [error, setError]                 = useState('')

    useEffect( () =>{
         if(rotaWeekTemplateEntryID){
            api.getRotaWeekTemplateEntryAppointmentTypeList( rotaWeekTemplateEntryID )
            .then( r => r.apiResult.map( a => a.pkAppointmentTypeID ) )
            .then( r => setSelectedAppTypes( r ) )
        }else{
            setSelectedAppTypes([])
        }
    },[api, rotaWeekTemplateEntryID] )

    const saveRota = () => {
        //let calendarApi = selectInfo.view.calendar
        
        const startSt = getTimeStr( startTime );
        const endStr  = getTimeStr( endTime );

        if(rotaWeekTemplateEntryID){
            api.updateRotaTemplateEntry(rotaWeekTemplateEntryID, 
                templateID, startSt, endStr, dayOfWeek, rotaTypeID, rowVersion)
                        .then( response => api.SaveRotaWeekTemplateEntryAppointmentType( rotaWeekTemplateEntryID, selectedAppTypes ) )
            .then( r => done() )
            .catch( e => setError( e.apiText ) )
        }else{
            api.createRotaTemplateEntry(templateID, startSt, endStr, 
                dayOfWeek, rotaTypeID)
            .then( response => api.SaveRotaWeekTemplateEntryAppointmentType( response.apiResult.RotaWeekTemplateEntryID, selectedAppTypes ) )
            .then( r => done() )
            .catch( e => setError( e.apiText ) )
        }
    }


    useEffect( () => {
        
        api.getRotaTypeList()
            .then( response => response.apiResult )
            .then( r => r.filter( rt => !isRotaTypeHidden( rt.RotaTypeID ) ) )
            .then( r        => {
                setRTypeList(r);
                //setRotaTypeID(r[0].RotaTypeID)
            })
            .catch( e => console.log(e) )
        } , [api] )
    
    const handleClick = e => {
        
        e.preventDefault()
        saveRota()
    }
     
    const handleChange = e => {
        
        if(e.target.name === 'typeSelect'){
            setRotaTypeID( Number.parseInt( e.target.value, 10 ) )
        }
    }
    
    const handleDeleteClick = e => {
        e.preventDefault()
        
        api.deleteRotaTemplateEntry( rotaWeekTemplateEntryID, templateID )
            .then( r => done() )
            .catch( err => setError( err.message ) )
           
    }
    
    return (
       
       <div style={{position: 'absolute', display: 'block', top: '50%', 
            left: '50%',backgroundColor: 'white', zIndex: '100', padding: '2em', 
            border: '3px solid var(--colour__primary)'}}  >
        
            <div className='wrapper'>
                {rotaWeekTemplateEntryID? <button    onClick={handleDeleteClick} >Delete</button>: ''}
            </div>
        
            <TwoTimeEdit start={startTime} end={endTime} onStartChange={setStartTime} 
            onEndChange={setEndTime} startLabel='From' endLabel='To' />
            
            <div>
            <label htmlFor='type-select' >Select the type:</label>
            <select name='typeSelect' onChange={handleChange} 
                value={rotaTypeID} >
                { rTypeList.map( t => (<option key={t.RotaTypeID} 
                value={t.RotaTypeID} >{t.Description}</option>) ) }
            </select>
            </div>
            
            {
            ROTA_TYPE_AVAIABLE === rotaTypeID?
            <>
            <h2>For Appointment Types</h2>
            <AppTypeSelector appointmentTypes={appointmentTypes}
            selectedAppTypes={selectedAppTypes} 
            setSelectedAppTypes={setSelectedAppTypes} />
            </>
            : null
            }
            
            <p></p>
            <OKCancel onOK={handleClick} okText='Save' onCancel={done} enabled={okEnabled} />
            {false? <><button onClick={handleClick} >Save</button><span> </span><span> </span>
            <a href='.' onClick={e=>{e.preventDefault();done()}} >Cancel</a> </>: null}
            
            <div>{error}</div>
       </div>
    )
}


export default TemplateCalendarOverlay

